export default __webpack_public_path__ + "static/media/background-2.a5563cdb.png";